import { useState, useRef, useEffect } from "react";
import { Loader } from "../../inc/Fetch";

const SearchUI = ({ data, plugin, searchPluginInstance }) => {
    
    // console.log(data);
    
    const lastKeywordRef = useRef("");
    const [keyword, setKeyword] = useState("");
    const [results, setResults] = useState([]);
    const [currentResult, setCurrentResult] = useState(0);
    
    const handleKeyDown = (e) => {
        if (e.key !== "Enter") return;

        if (e.shiftKey) {
            prevMatch();
            return;
        }

        if (lastKeywordRef.current !== keyword) {
            lastKeywordRef.current = keyword;
            runSearch();
        } else {
            nextMatch();
        }
    };


    
    const runSearch = () => {
    // 1. Clean the user input (remove spaces and diacritics from what they typed)
    const cleanInput = keyword.trim().replace(/\s+/g, '').replace(/[\u064B-\u0652]/g, '');

    // 2. Create a "Fuzzy" Arabic Regex
    // This inserts [\u064B-\u0652]* between every letter
    const harakat = '[\u064B-\u0652]*';
    const regexPattern = cleanInput.split('').join(harakat) + harakat;
    const arabicRegex = new RegExp(regexPattern, 'gi');

    // 3. Use the highlight method with the REGEX, not the string
    // This allows the plugin to find "يَاقُوت" even if the keyword is "ياقوت"
    searchPluginInstance.highlight(arabicRegex);

    const found = [];

    data.forEach((page) => {
        // Normalize the page text for the logical check (IF needed)
        const normalizedPageText = page.text.replace(/[\u064B-\u0652]/g, '').replace(/\s+/g, '');
        
        // We check against the cleanInput because normalizedPageText has no vowels
        if (normalizedPageText.includes(cleanInput)) {
            found.push(page.pageIndex);
        }
    });

    setResults(found);
    setCurrentResult(0);

    if (found.length > 0) {
        // jumpToPage is usually a property of the main viewer instance, 
        // make sure 'plugin' here refers to the file control plugin
        plugin.jumpToPage && plugin.jumpToPage(found[0]);
    }
};

    const nextMatch = () => {
        if (!results.length) return;

        const next = (currentResult + 1) % results.length;
        setCurrentResult(next);
        plugin.jumpToPage && plugin.jumpToPage(results[next]);
        // searchPluginInstance?.jumpToNextMatch();
    };

    // Navigate previous
    const prevMatch = () => {
        if (!results.length) return;

        const prev =
            (currentResult - 1 + results.length) % results.length;

        setCurrentResult(prev);
        plugin.jumpToPage && plugin.jumpToPage(results[prev]);
    };

    
    if (!data?.length) return <Loader />;

    return (
        <div className="searchBookBox">
            <input
                type="search"
                placeholder="ابحث في الكتاب..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                    padding: 6,
                    width: 250,
                    direction: "rtl",
                }}
            />
        </div>
    );
};

export default SearchUI;